import type { RouterConfig } from 'nuxt/schema'

// TODO: Re-enable non-exchange tenants when ready
// const tenants = 'paribu-self|custody|paribu-stock|money|pass'
// const tenantParam = `:tenant(${tenants})?`

export default {
  routes: () => [
    // Index
    {
      name: 'index',
      path: '/',
      component: () => import('@/pages/index/index.vue'),
    },

    // Health check
    // {
    //   name: 'health',
    //   path: '/health',
    //   component: () => import('@/pages/health.vue'),
    // },

    // Dictionary - Modül pasif (harici URL'e yönlendirildi: https://www.paribu.com/blog/sozluk/)
    // Tekrar aktif etmek için aşağıdaki route'ları yorum satırından çıkarın
    // {
    //   name: 'dictionary',
    //   path: `/:page(dictionary|sozluk)`,
    //   component: () => import('@/pages/dictionary/index.vue'),
    // },
    // {
    //   name: 'dictionary-detail',
    //   path: `/:page(dictionary|sozluk)/:detail`,
    //   component: () => import('@/pages/dictionary/[detail]/index.vue'),
    // },
    // Ticket (Support Requests)
    {
      name: 'ticket',
      path: '/:page(ticket|destek-talebi)',
      component: () => import('@/pages/ticket/index.vue'),
    },

    // Announcement (Duyurular) — helpdesk-core support announcements.
    // Flat list (no categories/pagination); detail is resolved slug→id from
    // the list. Declared before the catch-all so /duyurular wins over /:category?/:detail.
    {
      name: 'announcement',
      path: `/:page(announcement|duyurular)`,
      component: () => import('@/pages/announcement/index.vue'),
    },
    {
      name: 'announcement-detail',
      path: `/:page(announcement|duyurular)/:detail`,
      component: () => import('@/pages/announcement/[detail]/index.vue'),
    },

    // Status
    // {
    //   name: 'status',
    //   path: `/:page(status)`,
    //   component: () => import('@/pages/status/index.vue'),
    // },
    // {
    //   name: 'status-detail',
    //   path: `/:page(status)/:detail`,
    //   component: () => import('@/pages/status/[detail]/index.vue'),
    // },

    // Search
    {
      name: 'search',
      // TODO: Re-enable non-exchange tenants when ready
      // path: `/:page(search|arama)/:tenant(exchange|paribu-self|custody|paribu-stock|money|pass)?`,
      path: `/:page(search|arama)`,
      component: () => import('@/pages/search/index.vue'),
    },

    // // Settings
    // {
    //   name: 'settings-language-preferences',
    //   path: `/:page(settings/language-preferences|ayarlar/dil-secenekleri)`,
    //   component: () => import('@/pages/settings/language-preferences.vue'),
    // },

    // Categories index page
    {
      name: 'categories-index',
      path: '/categories',
      component: () => import('@/pages/categories/index.vue'),
    },

    // Dictionary
    // {
    //   name: 'dictionary',
    //   path: '/dictionary',
    //   component: () => import('@/pages/dictionary/index.vue'),
    // },
    // {
    //   name: 'dictionary-detail',
    //   path: '/dictionary/:detail',
    //   component: () => import('@/pages/dictionary/[detail]/index.vue'),
    // },

    // Status
    // {
    //   name: 'status',
    //   path: '/status',
    //   component: () => import('@/pages/status/index.vue'),
    // },
    // {
    //   name: 'status-detail',
    //   path: '/status/:detail',
    //   component: () => import('@/pages/status/[detail]/index.vue'),
    // },

    // Categories or Content
    {
      name: 'categories',
      // TODO: Re-enable non-exchange tenants when ready
      // path: `/:tenant(exchange|${tenants})`,
      path: `/:tenant(exchange)`,
      component: () => import('@/pages/categories/index.vue'),
    },
    {
      name: 'categories-or-content',
      // TODO: Re-enable non-exchange tenants when ready
      // path: `/${tenantParam}/:category?/:detail`,
      path: `/:category?/:detail`,
      component: () => import('@/pages/[catch-categories-or-content].vue'),
    },
  ],
} satisfies RouterConfig
